import Box from '@material-ui/core/Box';
import { TeamCostSummary } from '@internal/schemas-common';
import Typography from '@material-ui/core/Typography';
import { getCategoryColor } from '../../../helpers/colors';
import { useStyles } from './overspendIndicator.style';

type OverspendIndicatorProps = Readonly<
  Pick<TeamCostSummary, 'overspend' | 'color'>
> & { hasCostData: boolean };

function OverspendIndicator({
  overspend,
  color,
  hasCostData,
}: OverspendIndicatorProps) {
  const { cx, classes } = useStyles();

  return (
    <Box
      width="13rem"
      height="13rem"
      borderRadius="50%"
      bgcolor={getCategoryColor(color)}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <div className={cx(classes.overspendIndicator)}>
        {!hasCostData ? (
          <Typography variant="h3">No data available</Typography>
        ) : (
          <>
            <Typography variant="h4">${overspend?.toFixed(2)}</Typography>
            <Typography variant="subtitle1">overspend</Typography>
            <Typography variant="subtitle2">per month</Typography>
          </>
        )}
      </div>
    </Box>
  );
}

export { OverspendIndicator };
